// Dispatcher across the web parsers. Picks the right per-format
// parser by file extension (with a tiny sniff fallback for .fdx
// files that don't actually contain XML — common when a Fountain
// file gets renamed). Mirrors src/main/parsers/index.js.

import { parseFountain } from './fountain.js';
import { parseFDX } from './fdx.js';
import { parsePDF } from './pdf.js';
import { buildScriptFromRawParse } from './fountain.js';

function looksLikeXml(text) {
  if (typeof text !== 'string') return false;
  const lead = text.replace(/^﻿/, '').trimStart();
  return lead.startsWith('<');
}

// `input` is either { text } (for fountain / FDX text) or { bytes }
// (for PDFs — pdfjs needs raw bytes). `extension` is the lowercase
// `.fountain` / `.fdx` / `.pdf` / `.txt`. `filePath` is the file's
// display name (we never persist a real OS path on web).
export async function parseAny({ text, bytes, extension, filePath, title }) {
  const ext = (extension || '').toLowerCase();
  let parsed;
  let format;

  if (ext === '.pdf') {
    if (!bytes) throw new Error('PDF parsing requires raw bytes');
    format = 'pdf';
    parsed = await parsePDF(bytes);
  } else if (ext === '.fdx' && typeof text === 'string' && looksLikeXml(text)) {
    format = 'fdx';
    parsed = await parseFDX(text);
  } else if (typeof text === 'string') {
    // Either explicit .fountain / .txt, or an .fdx that turned out
    // to be Fountain (renamed / Dropbox conflict copy). Fall back
    // to Fountain so the writer's content isn't lost.
    format = ext === '.fountain' || ext === '.fdx' ? 'fountain' : 'plaintext';
    parsed = parseFountain(text);
  } else {
    throw new Error(`Unsupported import for extension "${ext}"`);
  }

  return buildScriptFromRawParse(parsed, { filePath, title, format });
}

export { parseFountain, parseFDX, parsePDF };
